/**
 * PATCH `admin/clients/:id/doctors/:doctorId` — правка врача админ-сайдом.
 * Передаются только изменённые поля.
 */

import {apiEnabled, http} from '@services/utils';
import {toE164} from '@utils/phone';

import {buildClientDetail, patchDetailMock} from '../detailMocks';
import {getSpecializations} from '../getSpecializations';
import {MOCK_CLIENTS} from '../mocks';

export type UpdateDoctorInput = {
  clientId: string;
  doctorId: string;
  fullName?: string;
  phone?: string;
  /** Имя специализации из справочника */
  specialization?: string;
};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const updateDoctor = async (input: UpdateDoctorInput): Promise<{ok: true}> => {
  if (!apiEnabled) {
    await sleep(300);
    const row = MOCK_CLIENTS.find((c) => c.id === input.clientId);
    if (row) {
      patchDetailMock(input.clientId, {
        staff: buildClientDetail(row).staff.map((d) =>
          d.id === input.doctorId
            ? {
                ...d,
                ...(input.fullName !== undefined ? {fullName: input.fullName.trim()} : {}),
                ...(input.phone !== undefined ? {phone: `+996 ${input.phone}`} : {}),
                ...(input.specialization !== undefined
                  ? {specialization: input.specialization}
                  : {}),
              }
            : d,
        ),
      });
    }
    return {ok: true};
  }

  const specializationId = input.specialization
    ? ((await getSpecializations()).find((s) => s.name === input.specialization)?.id ?? null)
    : undefined;

  await http(
    `admin/clients/${encodeURIComponent(input.clientId)}/doctors/${encodeURIComponent(input.doctorId)}`,
    {
      method: 'PATCH',
      body: {
        ...(input.fullName !== undefined ? {fullName: input.fullName.trim()} : {}),
        ...(input.phone !== undefined ? {phone: toE164(input.phone)} : {}),
        ...(specializationId !== undefined ? {specializationId} : {}),
      },
      skipCaseConversion: true,
    },
  );
  return {ok: true};
};
